module.exports = __webpack_public_path__ + "img/Radio selected Icon - white.1f62f56b.svg";